module.exports = "<div class=\"modal-body\">\n  <p class=\"lead\" *ngIf=\"title\" [innerHTML]=\"title | translate\"></p>\n  <p *ngIf=\"content\" [innerHTML]=\"content | translate\"></p>\n  <div class=\"button-bar\">\n    <button type=\"button\" class=\"btn btn-link btn-sm\" (click)=\"cancelClick()\">\n      {{ cancel | translate }}\n    </button>\n    <button type=\"button\" class=\"btn btn-primary btn-sm\" (click)=\"acceptClick()\">\n      {{ confirm | translate }}\n    </button>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/confirm/confirm.component.html
// module id = qeIs
// module chunks = 0